module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/24.dbcb3fa2.jpg";